import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Target, User, Building2, Network, Layers } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const ICON = { kpi: Target, employee: User, entity: Building2, department: Network, sub_entity: Layers };

export function GlobalSearch() {
  const [q, setQ] = useState(""); const [res, setRes] = useState([]); const [open, setOpen] = useState(false); const [idx, setIdx] = useState(0);
  const ref = useRef(null); const box = useRef(null); const nav = useNavigate();
  useEffect(() => {
    const onKey = (e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); ref.current?.focus(); } };
    const onClick = (e) => { if (!box.current?.contains(e.target)) setOpen(false); };
    window.addEventListener("keydown", onKey); document.addEventListener("mousedown", onClick);
    return () => { window.removeEventListener("keydown", onKey); document.removeEventListener("mousedown", onClick); };
  }, []);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => { setRes(r.data); setIdx(0); setOpen(true); }).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const go = (r) => { nav(r.link); setOpen(false); setQ(""); ref.current?.blur(); };
  const onKeyDown = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setIdx((i) => Math.min(i + 1, res.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx((i) => Math.max(i - 1, 0)); }
    else if (e.key === "Enter" && res[idx]) go(res[idx]);
    else if (e.key === "Escape") setOpen(false);
  };
  return (
    <div ref={box} className="relative">
      <div className="relative">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <input ref={ref} data-testid="global-search-input" value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => res.length && setOpen(true)} onKeyDown={onKeyDown}
          placeholder="Cari KPI, karyawan, entitas..." className="h-9 w-44 sm:w-64 lg:w-80 rounded-md border border-slate-200 bg-slate-50 pl-8 pr-12 text-sm outline-none focus:border-slate-900 focus:bg-white transition-colors" />
        <kbd className="hidden sm:block absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-slate-400 border border-slate-200 rounded px-1">Ctrl K</kbd>
      </div>
      {open && q.trim().length >= 2 && (
        <div data-testid="global-search-results" className="absolute left-0 mt-1 w-[26rem] max-w-[90vw] bg-white border border-slate-200 rounded-md shadow-lg overflow-hidden z-50">
          {res.length === 0 && <div className="px-3 py-3 text-sm text-slate-500" data-testid="global-search-empty">Tidak ada hasil untuk "{q}"</div>}
          {res.map((r, i) => { const I = ICON[r.type] || Search; return (
            <button key={r.link} data-testid={`global-search-result-${i}`} onMouseEnter={() => setIdx(i)} onClick={() => go(r)}
              className={cn("w-full flex items-center gap-3 px-3 py-2 text-left border-b last:border-0", i === idx ? "bg-slate-900 text-white" : "hover:bg-slate-50")}>
              <I size={14} className="shrink-0 opacity-70" />
              <div className="min-w-0"><div className="text-sm font-medium truncate">{r.label}</div><div className={cn("text-[11px]", i === idx ? "text-slate-300" : "text-slate-500")}>{r.sub}</div></div>
            </button>); })}
        </div>
      )}
    </div>
  );
}
